<template>
    <div class="text-2xl mt-3">
        <img v-bind:src="articleItem.leadimage">
            <h1 class="font-extrabold text-4xl md:text-5xl m-0 p-0 mb-4 mt-6 borderelement text-secondary-text">
                <the-text-view :value="articleItem.title_de" />
            </h1>
    </div>
</template>


<script>

    import TheTextView from '../TheTextView'

    export default {
        name: 'LeadArticle',
        components: {
            TheTextView
        },
        data() {
            return {
            }
        },

        props: {
            articleItem: {
                type: Object,
                default: () => {}
            }
        },
        created: function() {

        }
    }
</script>

<style lang="scss" scoped>
    img{
        margin-left: -0.75rem;
        margin-right: -0.75rem;
        min-width: 100vw;
        @screen md{
            margin-left: auto;
            margin-right: auto;
            min-width: auto;
        }
    }
    .borderelement{
        padding-left: 20px;
        padding-right: 20px;
        &:before,
        &:after{
            content: '';
            width: 12px;
            height: 24px;
            position: absolute;
        }
        &:before{
            @apply bg-primary-orange;
            left: 0;
            top: 0;
        }
        &:after{
            @apply bg-primary-blue;
            right: 0px;
            bottom: 0;
        }
    }
</style>